import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-white field-grid-light py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-220" data-mp="o7b968omkoeg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="j883qn4qgg5y">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-222" data-mp="j5c7d38j9zjm">
          Everything included
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-223" data-mp="1bwvv90g2s1ry">
          {productName} · {totalVolumes} volumes + {totalBonuses} bonuses · <b className="text-ink" data-id="element-224" data-mp="16v6hve5drc0p">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-225" data-mp="12vft1fzez5yt">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-cream p-4" data-id="element-226" data-mp="3rn8nmtttkiil">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forestSoft" data-id="element-227" data-mp="3nl59tyjoh1u5">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-228" data-mp="3idxq0ygkan2x" />
              </span>
              <p data-id="element-229" data-mp="3nao8ttjr3ws1">
                <b className="block text-sm text-ink" data-id="element-230" data-mp="3nb7qd95hoj5j">{feature}</b>
                <span className="text-sm text-muted" data-id="element-231" data-mp="39b6e6xjrxpar">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-earth bg-earthSoft px-6 py-5 text-center text-lg font-bold leading-relaxed text-ink" data-id="element-232" data-mp="3dc8ihssjsrjl">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}